import { createFeatureSelector, createSelector } from "@ngrx/store";
import { StoredProceduresState } from "./stored-procedures.reducer";

const selectStoredProcedureFeature = createFeatureSelector<StoredProceduresState>("storedProcedures")

export const selectStoredProcedures = createSelector(selectStoredProcedureFeature, state => {
  return state.list;
})